export const ADMIN_ROLES = Object.freeze({
  ADMIN: "ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
  CUSTOMER_SERVICE: "CUSTOMER_SERVICE",
  SALES: "SALES",
});

export type AdminRole = (typeof ADMIN_ROLES)[keyof typeof ADMIN_ROLES];

/**
 * The two roles that may perform privileged store mutations — reversing a
 * payment, withdrawing a storefront's Tag Manager container. Mirrors the
 * backend's `MANAGING_ADMIN_ROLES` / `ManagingAdminGuard`, which is what
 * actually enforces it; this exists so the UI hides controls the API would
 * refuse, and so the pair stops being copy-pasted inline per page.
 */
export const MANAGING_ADMIN_ROLES: readonly AdminRole[] = [
  ADMIN_ROLES.ADMIN,
  ADMIN_ROLES.SUPER_ADMIN,
];

export function hasManagingAdminRole(
  roles: readonly string[] | null | undefined,
): boolean {
  const allowed: readonly string[] = MANAGING_ADMIN_ROLES;
  return (roles ?? []).some((role) => allowed.includes(role));
}

/**
 * Delete-forever on a store is SUPER_ADMIN only (backend `SuperAdminGuard`).
 * Same contract as above: the UI mirrors, the API enforces.
 */
export function hasSuperAdminRole(
  roles: readonly string[] | null | undefined,
): boolean {
  return (roles ?? []).includes(ADMIN_ROLES.SUPER_ADMIN);
}
